import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CompetenciesService } from 'src/app/services/competencies/competencies.service';
import { SearchMenuService } from 'src/app/services/search-menu/search-menu.service';
import { SearchService } from 'src/app/services/search/search.service';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { WindowScrollService } from 'src/app/services/window-scroll/window-scroll.service';
import { ScreenSizeService } from 'src/app/services/screen-size/screen-size.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { I18nHelperService } from '@xref/ngx';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CategoriesService, Category } from 'src/app/services/categories/categories.service';

@Component({
    selector: 'xqnr-search-menu',
    templateUrl: './search-menu.component.pug',
    styleUrls: ['./search-menu.component.scss'],
    standalone: false
})
export class SearchMenuComponent implements OnInit {
  @ViewChild('searchMenuListRef') searchMenuListRef: ElementRef;

  loaded = false;

  competenciesList = [];
  categoriesList: Category[] = [];

  listScrollable = false;

  fa = {
    chevronRight: faChevronRight
  };

  categorySearchPrefill = {
    essential: 'essential',
    person: 'personality attributes',
    role: 'role-specific'
  };

  constructor(
    private competencies: CompetenciesService,
    private categories: CategoriesService,
    private search: SearchService,
    public searchMenu: SearchMenuService,
    private backdrop: BackdropService,
    private windowScroll: WindowScrollService,
    private screenSize: ScreenSizeService,
    public i18nHelper: I18nHelperService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.getCompetencies();
    this.getCategories();

    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (activeState === false) {
        this.searchMenu.hide();
        this.resetScrollable();
        this.windowScroll.allowWindowScroll();
      }
    });

    this.searchMenu.active$.subscribe((activeState: boolean) => {
      if (activeState) {
        this.setScrollable();
      }

      if (activeState && this.screenSize.lte(this.screenSize.md)) {
        this.windowScroll.preventWindowScroll();
      }
    });

    // Any list of competencies needs to be re-called with any login/logout,
    // As the list must be 20 for non-authed users and 60 for authed
    this.auth.loggedIn$.subscribe(() => {
      this.getCompetencies();
    });
  }

  setLoaded() {
    this.loaded = (
      this.competenciesList.length > 0 &&
      this.categoriesList.length > 0
    );
  }

  setScrollable() {
    const compHeight = this.searchMenuListRef.nativeElement.offsetHeight;
    const winHeight = window.innerHeight;

    if (compHeight > winHeight) {
      this.listScrollable = true;
    } else {
      this.resetScrollable();
    }
  }

  resetScrollable() {
    this.listScrollable = false;
  }

  getCompetenciesSuccess = (data: any) => {
    this.competenciesList = data;
    this.setLoaded();
  };

  getCompetencies() {
    this.competencies.getCompetencies().subscribe(this.getCompetenciesSuccess);
  }

  getCategoriesSuccess = (data: Category[]) => {
    this.categoriesList = data;
    this.setLoaded();
  };

  getCategories() {
    this.categories.getCategories().subscribe(this.getCategoriesSuccess);
  }

  searchForCategory(keyword: string) {
    const cat: Category = this.categoriesList.filter((category) => category.key === keyword)[0];

    this.search.searchFor(cat.content[this.i18nHelper.locale]);

    this.hide();
  }

  searchForCompetency(keyword: string) {
    this.search.searchFor(keyword);
    this.hide();
  }

  hide() {
    this.searchMenu.hide();
    this.backdrop.hide();
  }
}
